import { render, staticRenderFns } from "./XmpUploadComponent.vue?vue&type=template&id=3fd73d11&scoped=true&"
import script from "./XmpUploadComponent.vue?vue&type=script&lang=ts&"
export * from "./XmpUploadComponent.vue?vue&type=script&lang=ts&"
import style0 from "./XmpUploadComponent.vue?vue&type=style&index=0&id=3fd73d11&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fd73d11",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VFileInput } from 'vuetify/lib/components/VFileInput';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCol,VFileInput,VIcon,VRow})
